import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { ONUListPage } from '@/features/monitoring/onu-list'

export const Route = createFileRoute('/_authenticated/monitoring/onus')({
  component: () => (
    <RequirePermission permission='monitoring.read'>
      <ONUListPage />
    </RequirePermission>
  ),
})
